import "./footer.css";
import logo from "assets/images/others/logo.png"
// import logo1 from "assets/images/others/logo3.png"
import { useState } from "react";
import { ChevronLeft } from '@material-ui/icons';

const Footer = () => {
  const [termsModal, setTermsModal] = useState(false);
  const handleModal = () => {
    if(termsModal){
      setTermsModal(false);
      document.body.classList.remove('no-scroll');
    }else{
      setTermsModal(true);
      document.body.classList.add('no-scroll');
    }
  }
  return (
    <>
    <footer className="footer">
      <div className="container ft-top-sec row">
        <div className="infos column">
          <div className="column">
            <div className="logo row">
              <div className="picto"><img src={logo} alt="" /></div>
            </div>
          </div>
        </div>
        <div className="right row column">
          <div className="social row">
            <div className="link">
              <a
                href="https://www.instagram.com/cootie_nft"
                rel="noopener noreferrer"
                target="_blank"
                className="insta row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://twitter.com/CootiesNFTs"
                target="_blank"
                rel="noopener noreferrer"
                className="twitter row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://discord.com/invite/XzHc5M93B4"
                target="_blank"
                rel="noopener noreferrer"
                className="discord row"
              >.</a>
            </div>
            <div className="link">
              <a
                href="https://t.me/cootiesNFTs"
                target="_blank"
                rel="noopener noreferrer"
                className="tele row"
              >.</a>
            </div>
          </div>
          {/* <button onClick={handleModal} className="f-terms-btn">Terms & Conditions</button> */}

        </div>
      </div>
    </footer>
     {/* {termsModal &&
        <>
          <div onClick={handleModal} className="backdrop-sidebar"></div>
          <div className="model-wrapper">
            <div className="model-header">
              <div className="model-container row">
                <div className="model-close-btn" onClick={handleModal}>
                  <ChevronLeft className="ft-chev" />
                </div>
                <div className="modal-logo row">
                  <img src={logo1} alt="" />
                  <h4 className="modal-logo-text">
                    Business Ape Club
                  </h4>
                </div>
              </div>
            </div>
            <div className="model-container">

              <div className="modal-body">
                <h3 className="terms-head">TERMS & CONDITIONS</h3>
                <p>
                Mutant Mingos is a collection of digital artworks (NFTs) running on the Ethereum network. This website is only an interface allowing participants to exchange digital collectibles. Users are entirely responsible for the safety and management of their own private Ethereum wallets and validating all transactions and contracts generated by this website before approval.               
                 </p>
                 <p>
                 Furthermore, as the Mutant Mingo smart contract runs on the Ethereum network, there is no ability to undo, reverse, or restore any transactions.
                 </p>
                 <p>
                 This website and its connected services are provided “as is” and “as available” without warranty of any kind. By using this website you are accepting sole responsibility for any and all transactions involving Mutant Mingos NFTs.
                 </p>
                <h3 className="terms-head">OwnerShip</h3>
                <p>
                i. You Own the NFT. Each Mingo is an NFT on the Ethereum blockchain. When you purchase an NFT, you own the underlying Mingo, the Art, completely. Ownership of the NFT is mediated entirely by the Smart Contract and the Ethereum Network: at no point may we seize, freeze, or otherwise modify the ownership of any Mingo.

                </p>
                <p>
                ii. Personal Use. Subject to your continued compliance with these Terms, Mutant Mingos grants you a worldwide, royalty-free license to use, copy, and display the purchased Art, along with any extensions that you choose to create or use, solely for the following purposes: (i) for your own personal, non-commercial use; (ii) as part of a marketplace that permits the purchase and sale of your Mingo / NFT, provided that the marketplace cryptographically verifies each Mingo owner’s rights to display the Art for their Mingo to ensure that only the actual owner can display the Art; or (iii) as part of a third party website or application that permits the inclusion, involvement, or participation of your Mingo, provided that the website/application cryptographically verifies each Mingo owner’s rights to display the Art for their Mingo to ensure that only the actual owner can display the Art, and provided that the Art is no longer visible once the owner of the Mingo leaves the website/application.
                </p>
                <p>
                iii. Commercial Use. Subject to your continued compliance with these Terms, Mutant Mingos grants you an unlimited, worldwide license to use, copy, and display the purchased Art for the purpose of creating derivative works based upon the Art (“Commercial Use”). Examples of such Commercial Use would e.g. be the use of the Art to produce and sell merchandise products (T-Shirts etc.) displaying copies of the Art. For the sake of clarity, nothing in this Section will be deemed to restrict you from (i) owning or operating a marketplace that permits the use and sale of Mingo generally, provided that the marketplace cryptographically verifies each Mingo owner’s rights to display the Art for their Mingo to ensure that only the actual owner can display the Art; (ii) owning or operating a third party website or application that permits the inclusion, involvement, or participation of Mingo generally, provided that the third party website or application cryptographically verifies each Mingo owner’s rights to display the Art for their Mingo to ensure that only the actual owner can display the Art, and provided that the Art is no longer visible once the owner of the Purchased Mingo leaves the website/application; or (iii) earning revenue from any of the foregoing.
                </p>

              </div>
            </div>

          </div>
        </>
      }  */}
    </>
  );
};

export default Footer;
